import { render, staticRenderFns } from "./RequestReset.vue?vue&type=template&id=bc0b56c4&scoped=true&"
import script from "./RequestReset.vue?vue&type=script&lang=ts&"
export * from "./RequestReset.vue?vue&type=script&lang=ts&"
import style0 from "./RequestReset.vue?vue&type=style&index=0&id=bc0b56c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0b56c4",
  null
  
)

export default component.exports